import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bddd7df8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mcc-accordion" }
const _hoisted_2 = { class: "titles" }
const _hoisted_3 = { class: "mcc-accordion__label" }
const _hoisted_4 = {
  class: "icon mcc-accordion__caret mu-ml-auto",
  name: "expand_arrow",
  "aria-hidden": "true"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { id: "Icon" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector",
      d: "M21.7432 5.98928C21.5451 5.99396 21.3569 6.07681 21.2197 6.21975L12 15.4395L2.78027 6.21975C2.71036 6.14776 2.62672 6.09053 2.53429 6.05144C2.44187 6.01236 2.34254 5.99222 2.24219 5.99221C2.09293 5.99225 1.94707 6.03682 1.82328 6.12021C1.69949 6.20361 1.6034 6.32204 1.5473 6.46036C1.49119 6.59868 1.47763 6.75058 1.50835 6.89665C1.53907 7.04272 1.61266 7.1763 1.71973 7.2803L11.4697 17.0303C11.6104 17.1709 11.8011 17.2499 12 17.2499C12.1989 17.2499 12.3896 17.1709 12.5303 17.0303L22.2803 7.2803C22.3893 7.17562 22.4642 7.04043 22.4951 6.89245C22.526 6.74447 22.5115 6.59061 22.4534 6.45103C22.3953 6.31146 22.2965 6.19269 22.1697 6.11029C22.043 6.02789 21.8943 5.98571 21.7432 5.98928Z",
      fill: "currentcolor"
    })
  ])
], -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("details", _hoisted_1, [
    _createElementVNode("summary", {
      class: _normalizeClass(_ctx.additionalDetail ? '' : 'no-additional-detail')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _withDirectives(_createElementVNode("span", { class: "mcc-accordion__label subtitle" }, _toDisplayString(_ctx.subtitle), 513), [
          [_vShow, _ctx.subtitle]
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_6, 512), [
        [_vShow, _ctx.additionalDetail || _ctx.isDetailPanel]
      ])
    ], 2),
    _withDirectives(_createElementVNode("div", { class: "mcc-accordion__body" }, _toDisplayString(_ctx.additionalDetail), 513), [
      [_vShow, _ctx.additionalDetail]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "details-panel", {}, undefined, true)
    ], 512), [
      [_vShow, _ctx.isDetailPanel]
    ])
  ]))
}